import CircularProgress from '@mui/material/CircularProgress'
import { connectorApi } from 'api/connector/api'
import { useHistory } from 'react-router-dom'
import { notifyError } from 'shared/errors'
import { useAppSelector } from 'shared/hooks'
import { Button, StackIcon } from 'shared/ui'

import { appSelectors } from '../../../../redux/reducers/app'
import css from './SignIn.module.scss'
export function SignInMember({ id = '' }: { id?: string }) {
	const personaId = useAppSelector(
		state => appSelectors.persona(state)?.personaId
	)
	const isImpersonated = useAppSelector(appSelectors.isImpersonated)
	const [changePerson, { isLoading }] =
		connectorApi.useSignInUnderTeamMemberMutation()
	const { push } = useHistory()

	const isRestricted = personaId === id || isImpersonated

	if (isRestricted) {
		return null
	}

	const signIn = () => {
		if (!isLoading) {
			changePerson(id)
				.unwrap()
				.then(() => push('/campaigns'))
				.catch(notifyError)
		}
	}

	return (
		<Button className={css.action} onClick={signIn} type='button'>
			{isLoading ? (
				<CircularProgress
					classes={{ colorPrimary: 'material-loader-black' }}
					size={14}
				/>
			) : (
				[<StackIcon icon='sign-in' key='➡️' width={14} />, 'Sign in']
			)}
		</Button>
	)
}
